module.exports = __webpack_public_path__ + "static/media/PioneerGS.8bf77748.pdf";